import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { isVideoFile } from "../../shared/fileUtils";

type DressCardProps = {
    imageUrl: string;
    name: string;
}

const DressCard: React.FC<DressCardProps> = ({ imageUrl, name }) => {
    const [mediaLoaded, setMediaLoaded] = useState(false);
    const [currentSrc, setCurrentSrc] = useState(imageUrl);
    const [useSrcSet, setUseSrcSet] = useState(true);
    const { t } = useTranslation();

    const fileExtension = imageUrl.slice(imageUrl.lastIndexOf('.'));
    const baseImageUrl = imageUrl.replace(fileExtension, '');
    const isVideo = isVideoFile(imageUrl);
    const imageSrcSet = !isVideo && useSrcSet ? `
        ${baseImageUrl}-thumbnail${fileExtension} 480w,
        ${baseImageUrl}-medium${fileExtension} 800w
    ` : '';

    const handleError = () => {
        setUseSrcSet(false);
        if (currentSrc !== imageUrl) {
            setCurrentSrc(imageUrl);
        }
    };

    return (
        <div className="relative overflow-hidden w-full min-h-[200px] h-auto rounded-lg">
            {!mediaLoaded && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-200 rounded-lg">
                    <span>{t("global.loading")}...</span>
                </div>
            )}
            {isVideo ? (
                <video
                    className={`w-full h-full object-cover rounded-lg shadow-lg ${mediaLoaded ? 'block' : 'hidden'}`}
                    onCanPlay={() => {
                        console.log('Video can play');
                        setMediaLoaded(true);
                    }}
                    onLoadedData={() => {
                        console.log('Video loaded data');
                        setMediaLoaded(true);
                    }}
                    onError={(e) => {
                        console.error('Video error:', e);
                        handleError();
                    }}
                    src={currentSrc}
                    muted
                    playsInline
                    autoPlay
                    loop
                    preload="auto"
                >
                    Your browser does not support the video tag.
                </video>
            ) : (
                <Zoom zoomMargin={10}>
                    <img
                        srcSet={imageSrcSet.trim()}
                        src={currentSrc}
                        alt={name}
                        className={`w-full h-full object-cover rounded-lg transform hover:scale-105 transition duration-1000 shadow-lg cursor-pointer ease-in-out ${mediaLoaded ? 'block' : 'hidden'}`}
                        onLoad={() => setMediaLoaded(true)}
                        onError={handleError}
                    />
                </Zoom>
            )}
            {name && 
                <div className="absolute bottom-0 w-full text-center py-2 bg-white bg-opacity-50 rounded-b-lg">
                    <h3 className="text-lg font-bold text-gray-700">{name}</h3>
                </div>
            }
        </div>
    );
};

export default DressCard;